import { StateUser } from '@/interfaces/state.usuario.interfaces'

const mutations = {
  login (state: StateUser, payload: any) {
    state.token = payload.token
  },
  authData (state: StateUser) {
    if (state.token) {
      return
    }

    if (localStorage.getItem('token')) {
      state.token = localStorage.getItem('token') || ''
    }
  },
  datosAuth (state: StateUser, payload: any) {
    state.datosPerfil = payload
  },
  salir (state: StateUser, payload: any) {
    state.datosPerfil = {}
    state.token = ''
  }

}

export default mutations
